
import axios from 'axios';
import React from "react";
import { connect } from "react-redux";
import history from "../../auth/history";
import XMLParser from 'react-xml-parser';

import { v4 as uuidv4 } from 'uuid';
import { store } from "../../redux/store";
import $ from 'jquery';
import { checkingDriverStatus, setBiometricDta, setBiometricDtaCaptureStatus } from '../../redux/retailer-kyc-details/retailer-kyc-details.action';

var finalUrl = "";
var MethodInfo = "";
var MethodCapture = "";
var finalport = "";
var is_capture = false;
var finalRdServiceResponse = [];
var btnText = '';
var biomatricIndicater = '';
var deviceInfo = '';
var deviceErrorMsg = '';
var deviceErrorCode = '';
var capturedData = '';
const httpClient = axios.create();
class BioMetryCapture extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: '',
            refId: '',
            shopName: '',
            mobile: '',
            // agentFullName: "PRAKASH RAM JHUNJHUNWALA",
            // agentPan: "AAIPM3854E",
            // agentDateOfBirth: "22/07/1989",

            //response
            otpToken: '',
            kycToken: '',
            wadh: '',
            captureStatus: 'Off',

            version: '',
            serialNum: '',
            timeStamp: '',
            deviceXmlData: '',
            biomatricDeviceIndicaterClass: '',
            biomatricDeviceIndicater: '',
            submitBtnStatus: false,
            aadharNumber: '',
            req: ''



        }
    }

    captureDeviceInfoOnLoad() {



        //console.log('this.props', props.location.search)
        var discoverRDServiceResponse = this.discoverRDService1();
        var status = '';
        var discoverRDServiceFinalResponse = '';
        if (discoverRDServiceResponse.data != '') {

            if (discoverRDServiceResponse.data == 'error') {
                status = 'ERROR';
            } else {
                discoverRDServiceFinalResponse = new XMLParser().parseFromString(discoverRDServiceResponse.data);
            }

        }

        // var info = "Precision - Biometric Device is not connected to the system, please connect and try again"
        var info = discoverRDServiceFinalResponse != '' && discoverRDServiceFinalResponse.attributes.info != undefined ? discoverRDServiceFinalResponse.attributes.info : '';
        if (status != 'ERROR') {
            status = discoverRDServiceFinalResponse != '' && discoverRDServiceFinalResponse.attributes.status != undefined ? discoverRDServiceFinalResponse.attributes.status : '';//"NOTREADY"
        }

        console.log("discoverRDServiceFinalResponse__", discoverRDServiceFinalResponse.attributes);
        if (status == "READY") {
            // alert('Connect-device status ' + status);
            this.setState({ biomatricDeviceIndicaterClass: "connect" });
        } else {
            // alert('Connect-device status ' + status);
            this.setState({ biomatricDeviceIndicaterClass: "disconnect" });
        }
        this.setState({ biomatricDeviceIndicater: info });
        store.dispatch(checkingDriverStatus(status));
        return status;

    }

    captureData(wadh) {
        this.setState({ submitBtnStatus: true });
        var xmlDta = '';
        setTimeout(() => {
            //  if (is_capture == true) {

            var captureData = this.capture(wadh);

            /* var parser = new DOMParser();
             var xmlDoc = parser.parseFromString(finalRdServiceResponse, "text/xml");
             console.log("xmlDoc___", xmlDoc); */
            console.log("captureData___", captureData.data);

            capturedData = captureData.data;
            var Fingerprintxml = new XMLParser().parseFromString(captureData.data);

            console.log("Fingerprintxml ff", Fingerprintxml);
            var errCode = Fingerprintxml.children[0].attributes.errCode != undefined ? Fingerprintxml.children[0].attributes.errCode : '';

            Fingerprintxml.children[2].attributes.ci = "20221023"

            var versionV = Fingerprintxml.children[1].attributes.rdsVer
            var serialNumV = Fingerprintxml.children[1].children[0].children[0].attributes.value
            var timeStampV = Fingerprintxml.children[1].children[0].children[1].attributes.value

            this.setState({
                version: versionV,
                serialNum: serialNumV,
                timeStamp: timeStampV

            })

            //console.log("Fingerprintxml_data_",Fingerprintxml.children[0].attributes.errCode);
            if (errCode == 0) {
                // this.setState({ CaptureFingerprintData: Fingerprintxml });
                // store.dispatch(showAEPSCASHWITHDEAWALSection());
                alert("Finger Print capture successfully.");
                this.setState({ showModal: false });
                this.setState({ messagePopUpHidden: true })
                this.setState({ message: "Finger Print capture successfully." });
                this.setState({ severity: "success" });
                // store.dispatch(setBioMetricEncryptionXML({ bioMetricEncryptionXML: captureData.data }));

                xmlDta = captureData.data;
                alert('xmlData...'+xmlDta);
                store.dispatch(setBiometricDta(btoa(xmlDta)));
                store.dispatch(setBiometricDtaCaptureStatus('success'));

            } else {
                var errInfo = Fingerprintxml.children[0].attributes.errInfo != undefined ? Fingerprintxml.children[0].attributes.errInfo : '';
                alert('error in fingerprint capturing::' + errInfo);
                this.setState({ submitBtnStatus: false });
                store.dispatch(setBiometricDtaCaptureStatus('failed'));
                // this.setState({ showModal: false });
                // this.setState({ messagePopUpHidden: true })
                // this.setState({ message: errInfo });
                // this.setState({ severity: "error" });
            }
            //  }
        }, 100);

    }


    captureFingerPrint = async (wadh) => {

        this.captureData(wadh);

    }

    capture = (wadh) => {	

      
      
        
        // Get Capture Info from the path given by RDService Info
        var fCount = '1';
        var fType = 1;//document.getElementById('txtftype').value;
        // var fType = 'X';//document.getElementById('txtftype').value;
        var format = '0';
        var pidver = '2.0';
        var timeout = '10000';

        // var env='';
        // if(process.env.REACT_APP_ENV=='UAT'){
        //     env='PP';
        // }else if(process.env.REACT_APP_ENV=='PROD'){
        //     env='P';
        // }

        var env = 'PP';
        var lock = "";
        var iCount = 0;
        var iType = "";
        var pType = "";
        var pCount = 0;
        var wadh_value = wadh;
        //let finalUrl="http://127.0.0.1:11100";
        // finalUrl = process.env.REACT_APP_RDService_URL + finalport;
        finalUrl = 'http://127.0.0.1:' + finalport;
        console.log("Capture_", finalUrl);
        // Form input Pid OPtions for capture Input
        var XML = '<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="' + fCount + '" fType="' + fType + '" format="' + format + '" pidVer="' + pidver +
        '" timeout="' + timeout + '" env="' + env + '" wadh="' + wadh_value + '"   /> <CustOpts> <Param name="LockingKey" value="' + lock + '" /> </CustOpts> </PidOptions>';
        //   var XML = '<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="' + fCount + '" fType="' + fType + '" format="' + format + '" pidVer="' + pidver + '" timeout="' + timeout + '" env="' + env + '" wadh="' + wadh_value + '" /> <CustOpts> <Param name="LockingKey" value="' + lock + '" /> </CustOpts> </PidOptions>';
        //var XML = '<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="' + fCount + '" fType="' + fType + '" format="' + format + '" pidVer="' + pidver + '" timeout="' + timeout + '" env="' + env + '" /> <CustOpts> <Param name="LockingKey" value="' + lock + '" /> </CustOpts> </PidOptions>';
        console.log("XML_data_", XML);
        var verb = "CAPTURE";
        var err = "";
        var res;
        $.support.cors = true;
        var httpStaus = false;
        var jsonstr = "";
        $.ajax({
            type: "CAPTURE",
            async: false,
            crossDomain: true,
            url: finalUrl + MethodCapture,
            data: XML,
            contentType: "text/xml; charset=utf-8",
            processData: false,
            success: function (data) {
                var xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);
                //alert(xmlstr);
                data = xmlstr;
                //alert(data);
                httpStaus = true;
                var isBiomatric = true;
                res = { httpStaus: httpStaus, data: data };
                finalRdServiceResponse = data;
                $('#txtPidData').val(data);
                $('#txtPidOptions').val(XML);
                var deviceErrorMsg = $($doc).find('Resp').attr('errInfo');
                deviceErrorCode = 0;
                var $doc = $.parseXML(data);
                var Message = $($doc).find('Resp').attr('errInfo');
            },
            error: function (msg) {
                var result = msg.status + msg.statusText + msg.responseText;
                res = { httpStaus: false, data: result };
                alert(msg.responseText)
                var deviceErrorMsg = "Please reconnect biomatric device.";
                deviceErrorCode = 1;
                console.log("Error in Finger print capture ", res);

            }
        });
        // wher biomatric device not connected
        console.log("deviceErrorCode_", deviceErrorCode);
        if (deviceErrorCode == 1) {
            alert('deviceErrorMsg...' + deviceErrorMsg);
            this.setState({ showModal: false });
            this.setState({ messagePopUpHidden: true })
            this.setState({ message: deviceErrorMsg });
            this.setState({ severity: "error" });
            return false;
        }

        this.setState({ isBiomatricConnected: false });

        //  return false;
        return res;

    }


    discoverRDService1 = () => {
        
        var primaryUrl = 'http://127.0.0.1:';//"http://127.0.0.1:";
        //   alert(primaryUrl);
        var tempcount = 0;
        var url = "";
        $("#ddlRDS").empty();
        //alert("Discovering Precision RDService.\nPlease wait for some time.");

        var curPort = 11100;
        var xmlstr = '';

        var verb = "RDSERVICE";
        var err = "";

        //alert(i);
        var res;
        $.support.cors = true;
        var httpStaus = false;
        var jsonstr = "";
        var data = new Object();
        var obj = new Object();
        var xmlstr;
        var i = 11100;
        console.log("primaryUrl_____", primaryUrl + i.toString())
        $.ajax({
            type: "RDSERVICE",
            async: false,
            crossDomain: true,
            url: primaryUrl + i.toString(),
            contentType: "text/xml; charset=utf-8",
            processData: false,
            cache: false,
            timeout: 200,

            success: function (data) {
                xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);
                console.log("xmlstr___xmlstr", xmlstr);

                try {
                    xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);
                    //alert(xmlstr);
                    data = xmlstr;

                    httpStaus = true;
                    res = { httpStaus: httpStaus, data: data };
                    //alert(data);		
                    finalUrl = primaryUrl + i.toString();

                    var $doc = $.parseXML(xmlstr);
                    var CmbData1 = $($doc).find('RDService').attr('status');
                    var CmbData2 = $($doc).find('RDService').attr('info');



                    $("#ddlRDS").append('<option value=' + i.toString() + '>Port : ' + i.toString() + ' Status : ' + CmbData1 + '(' + CmbData2 + ')</option>')
                    tempcount++;
                }
                catch (e) {
                    
                }
            },
            error: function (msg) {

                var result = msg.status + msg.statusText + msg.responseText;
                res = { httpStaus: false, data:'error' };
                err='error';
                // alert( result);
                console.log("ajax_request_not msg", msg);
                console.log("ajax_request_not ", result);

            }

        });


        if (err != 'error') {
            console.log('data...' + res.data)
            res = this.discoverRDService();
        } else {
            console.log('error data...' + res.data)
        }


        return res;
    }


    //rd service
    discoverRDService = () => {
       		// Search for the valid RDService from port 11100 to 11120
        var primaryUrl = 'http://127.0.0.1:';//"http://127.0.0.1:";
        //   alert(primaryUrl);
        var tempcount = 0;
        var url = "";
        $("#ddlRDS").empty();
        //alert("Discovering Precision RDService.\nPlease wait for some time.");

        var curPort = 11100;
        var xmlstr = '';

        // while (curPort < 11120 && xmlstr == '') {

        //     var verb = "RDSERVICE";
        //     var err = "";

        //     //alert(i);
        //     var res;
        //     $.support.cors = true;
        //     var httpStaus = false;
        //     var jsonstr = "";
        //     var data = '';

        //     console.log("primaryUrl_____", primaryUrl + curPort.toString())
        //     $.ajax({
        //         type: "RDSERVICE",
        //         async: false,
        //         crossDomain: true,
        //         url: primaryUrl + curPort.toString(),
        //         contentType: "text/xml; charset=utf-8",
        //         processData: false,
        //         cache: false,
        //         timeout: 200,

        //         success: function (data) {

        //             xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);
        //             console.log("xmlstr___xmlstr", xmlstr);

        //             try {
        //                 xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);
        //                 //alert(xmlstr);
        //                 data = xmlstr;

        //                 httpStaus = true;
        //                 res = { httpStaus: httpStaus, data: data };
        //                 //alert(data);		
        //                 finalUrl = primaryUrl + curPort.toString();

        //                 var $doc = $.parseXML(xmlstr);
        //                 var CmbData1 = $($doc).find('RDService').attr('status');
        //                 var CmbData2 = $($doc).find('RDService').attr('info');

        //                 $("#ddlRDS").append('<option value=' + curPort.toString() + '>Port : ' + curPort.toString() + ' Status : ' + CmbData1 + '(' + CmbData2 + ')</option>')
        //                 tempcount++;

        //             }
        //             catch (e) {
        //                 console.log(e);
        //             }
        //         },
        //         error: function (msg) {
        //             res = { httpStaus: false, data: 'error' };
        //             xmlstr = 'ERROR';
        //             curPort = 11120;

        //             var result = msg.status + msg.statusText + msg.responseText;

        //             // alert( result);
        //             console.log("ajax_request_not msg", msg);
        //             console.log("ajax_request_not ", result);

        //         }

        //     });

        //     if (xmlstr != '' && xmlstr != undefined) {
        //         // alert('index..'+xmlstr.indexOf('Precision'))
        //         if (xmlstr.indexOf('Precision') > 0) {
        //             //alert(xmlstr);

        //             $("select#ddlRDS").prop('selectedIndex', tempcount - 1);
        //             finalport = curPort.toString();
        //             this.discoverFirstNode(curPort);

        //         }
        //     } else {
        //         curPort++;
        //     }
        // }

        for (var i = 11100; i <= 11120; i++) {
            var verb = "RDSERVICE";
            var err = "";

            //alert(i);
            var res;
            $.support.cors = true;
            var httpStaus = false;
            var jsonstr = "";
            var data = new Object();
            var obj = new Object();
            var xmlstr;
            console.log("primaryUrl_____", primaryUrl + i.toString())
            $.ajax({
                type: "RDSERVICE",
                async: false,
                crossDomain: true,
                url: primaryUrl + i.toString(),
                contentType: "text/xml; charset=utf-8",
                processData: false,
                cache: false,
                timeout: 200,

                success: function (data) {
                    xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);
                    console.log("xmlstr___xmlstr", xmlstr);

                    try {
                        xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);
                        //alert(xmlstr);
                        data = xmlstr;

                        httpStaus = true;
                        res = { httpStaus: httpStaus, data: data };
                        //alert(data);		
                        finalUrl = primaryUrl + i.toString();

                        var $doc = $.parseXML(xmlstr);
                        var CmbData1 = $($doc).find('RDService').attr('status');
                        var CmbData2 = $($doc).find('RDService').attr('info');

                        $("#ddlRDS").append('<option value=' + i.toString() + '>Port : ' + i.toString() + ' Status : ' + CmbData1 + '(' + CmbData2 + ')</option>')
                        tempcount++;
                    }
                    catch (e) { }
                },
                error: function (msg) {
                    alert(JSON.stringify(msg) + ':' + finalport);
                    var result = msg.status + msg.statusText + msg.responseText;
                    res = { httpStaus: false, data: 'error' };
                    // alert( result);
                    console.log("ajax_request_not msg", msg);
                    console.log("ajax_request_not ", result);

                }

            });

            if (xmlstr != null && xmlstr !=undefined && xmlstr !='')  {
                if (xmlstr.indexOf('Precision') > 0) {
                    //alert(xmlstr);

                    $("select#ddlRDS").prop('selectedIndex', tempcount - 1);
                    finalport = i.toString();
                    this.discoverFirstNode(i);
                    break;
                }
            }

        }
        return res;

    }

    discoverFirstNode = (PortNo) => {				// Get the Status of the RDService found by discoverRDService()
        $('#txtDeviceInfo').val('');
        $('#txtPidOptions').val('');
        $('#txtPidData').val('');

        //alert(PortNo);

        var primaryUrl = 'http://127.0.0.1:';//"http://127.0.0.1:";
        let url = "";
        var verb = "RDSERVICE";
        var err = "";
        var res;
        $.support.cors = true;
        var httpStaus = false;
        var jsonstr = "";
        var data = new Object();
        var obj = new Object();

        $.ajax({
            type: "RDSERVICE",
            async: false,
            crossDomain: true,
            url: primaryUrl + PortNo,
            contentType: "text/xml; charset=utf-8",
            processData: false,
            cache: false,
            async: false,
            crossDomain: true,
            success: function (data) {
                var xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);
                //alert(xmlstr);
                data = xmlstr;
                //alert(data);
                httpStaus = true;
                res = { httpStaus: httpStaus, data: data };
                //alert(data);		
                $('#txtRDSInfo').val(data);

                var $doc = $.parseXML(data);

                for (var j = 0; j < 2; j++) {
                    if ($($doc).find('Interface').eq(j).attr('id') == 'CAPTURE') {
                        MethodCapture = $($doc).find('Interface').eq(j).attr('path');
                    } else if ($($doc).find('Interface').eq(j).attr('id') == 'DEVICEINFO') {
                        MethodInfo = $($doc).find('Interface').eq(j).attr('path');
                    }
                }

                console.log("Precision RDSERVICE Discover Successfully");
                var parser = new DOMParser();
                var device1_response = parser.parseFromString($doc, "text/xml");
                // var biomatricIndicater='';biomatricDeviceIndicater
                //console.log("doc1___",reMethodCaptures," MethodInfo_"+MethodInfo);
                // biomatricIndicater = "Biometric device connected, scan fingerprint of the customer for Aadhaar authentication";
                is_capture = true;
            },
            error: function (msg) {
                is_capture = false;
                var result = msg.status + msg.statusText + msg.responseText;
                alert(result);

            }
        });
        this.deviceInfo();

        return res;

    }

    deviceInfo = () => {
        var url = "";
        finalUrl = 'http://127.0.0.1:' + finalport;
        var verb = "DEVICEINFO";
        //alert(finalUrl);

        var err = "";
        var res;
        //$.support.cors = true;
        var httpStaus = false;
        var jsonstr = "";
        $.ajax({
            type: "DEVICEINFO",
            async: false,
            crossDomain: true,
            url: finalUrl + MethodInfo,
            contentType: "text/xml; charset=utf-8",
            processData: false,
            success: function (data) {
                var xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);
                //alert(xmlstr);
                data = xmlstr;
                //alert(url);
                httpStaus = true;
                res = { httpStaus: httpStaus, data: data };

                $('#txtDeviceInfo').val(data);
                deviceInfo = data;
            },
            error: function (msg) {
                var result = msg.status + msg.statusText + msg.responseText;
                console.log("Error In device info", result);

            }
        });

        return res;


    }


}
export default new BioMetryCapture();